export default "__VITE_ASSET__CAukHgSh__"